import { useNavigate } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import { useDoctoralCommitteeCreate } from '@/module/Author/DoctoralCommittee/model/DoctoralCommitteeQuery';
import {
  DoctoralCommitteeSchema,
  defaultDoctoralCommitteeValues,
  doctoralCommitteeSchema,
} from '@/module/Author/DoctoralCommittee/model/DoctoralCommitteeSchema';

import { useAppNotification } from '@feature/utils';

import { DoctoralCommitteeForm } from './DoctoralCommitteeForm';

export function DoctoralCommitteeCreate() {
  const { t } = useTranslation();
  const { mutate, isPending, isError, isSuccess } = useDoctoralCommitteeCreate();

  const notification = useAppNotification();
  const navigate = useNavigate();

  const onSubmit = (values: DoctoralCommitteeSchema) => {
    mutate(values, {
      onError: notification.error,
      onSuccess: newDoctoralCommittee => {
        notification.success();
        navigate({
          to: '/author/doctoral-committee/$doctoralCommitteeId',
          params: { doctoralCommitteeId: String(newDoctoralCommittee.id) },
        });
      },
    });
  };

  return (
    <DoctoralCommitteeForm
      title={t('doctoralCommittees.form.title.create')}
      schema={doctoralCommitteeSchema}
      defaultValues={defaultDoctoralCommitteeValues}
      values={undefined}
      isSubmitting={isPending}
      isError={isError}
      isSuccess={isSuccess}
      onSubmit={onSubmit}
      onCancel={() => navigate({ to: '..' })}
    />
  );
}
